import React, { Component } from 'react';
import Phone from './Phone'
import Email from './Email'

class CustomerInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };
    }

    render() {
        var bp=this.props.bp;
        const changes=this.props.changes;
        if (changes.state.changedCustomer) bp=changes.state.changedCustomer;

        return <div className="mb-4">
            <div>{bp.salutation} {bp.initials} {bp.prefix} {bp.name} </div>
            <div>{bp.shippingAddress.street} {bp.shippingAddress.streetNumber} {bp.shippingAddress.building}</div>
            <div>{bp.shippingAddress.zipCode} {bp.shippingAddress.city}</div>
            <div>
                {bp.contact.phone1 &&
                    <span className="me-4">
                        <Phone value={bp.contact.phone1}></Phone>
                        
                    </span>}
            </div><div>
                {bp.contact.mobile &&
                    <span className="me-4">
                        <Phone value={bp.contact.mobile}></Phone>
                    </span>}
            </div>
            <div>
                {bp.contact.email  &&  
                    <div><Email value={bp.contact.email}></Email></div>
                }
            </div>
        </div> 
    }
}

export default CustomerInfo;